<template>
    <div>
        <div class="title-box">
            角色管理
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item>
                <el-select v-model="queryParams.roleName" filterable clearable placeholder="角色名称">
                    <el-option
                    v-for="item in options"
                    :key="item.roleName"
                    :label="item.roleName"
                    :value="item.roleName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
            <!-- 删除添加按钮 -->
            <span style="position:relative;float:right;bottom:14px;">
                <i v-hasPermi="['system:role:add']" @click="addClick()" style="background:#C7C7C7;cursor:pointer;color:#fff;width:32px;height:32px;text-align:center;margin-top:18px;padding-top:7px;border-radius:3px" class="el-icon-plus"></i>
                <i v-hasPermi="['system:role:remove']" @click="handleDelete()" style="background:#C7C7C7;cursor:pointer;color:#fff;width:32px;height:32px;text-align:center;margin-top:18px;margin-left:5px;padding-top:7px;border-radius:3px" class="el-icon-delete"></i>
            </span>
        </el-form>
        
        <!-- 表格 -->
        <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" @selection-change="handleSelectionChange" class="custom-table-header">
            <el-table-column type="selection" width="50" align="center"/>
            <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
            <el-table-column prop="roleName" label="角色名称" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="createTime" label="修改时间" align="center"></el-table-column>
            <el-table-column label="操作" width="220" align="center">
                <template slot-scope="scope" v-if="scope.row.roleKey !== 'admin'">
                    <el-button v-hasPermi="['system:role:edit']" style="color:#3083FB !important;" @click="handleEdit(scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-hasPermi="['system:role:remove']" style="color:#3083FB !important;" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                    <el-button v-hasPermi="['system:role:edit']" style="color:#3083FB !important;" @click="handleRight(scope.row)" type="text" size="small">数据权限</el-button>
                    <el-button v-hasPermi="['system:role:edit']" style="color:#3083FB !important;" @click="handleUser(scope.row)" type="text" size="small">分配用户</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 修改 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="726px" center :close-on-click-modal="false">
            <el-form  ref="roleFormRef" :model="dialogForm" :rules="rules" label-width="80px" style="padding:15;display:flex;">
                <div>
                    <el-form-item label="角色名称" style="width:200px;" prop="roleName">
                        <el-input v-model="dialogForm.roleName" style="width:146px;"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" style="width:200px;" prop="remark">
                        <el-input v-model="dialogForm.remark" type="textarea" :rows="5" style="width:146px" placeholder="请输入内容"></el-input>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-checkbox v-model="dialogForm.menuCheckStrictly" @change="handleCheckedTreeConnect($event, 'menu')">父子联动</el-checkbox>
                    </el-form-item>
                    <el-form-item label="设置角色权限" label-width="150px">
                        <el-tree
                            :data="treeData"
                            ref="tree"
                            show-checkbox
                            node-key="id"
                            :check-strictly="!dialogForm.menuCheckStrictly"
                            empty-text="加载中，请稍候"
                            style="width:320px;height:300px;overflow-y:auto;border:1px solid #DCDFE6;border-radius:5px;"
                            :props="{ label: 'label', children: 'children' }"
                            >
                        </el-tree>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="color:#000 !important;">取 消</el-button>
                <el-button type="primary" @click="handleAdd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 数据权限 -->
        <el-dialog title="分配数据权限" :visible.sync="dialogDataVisible" width="500px" center :close-on-click-modal="false">
            <el-form ref="dataScopeRef" :model="form" label-width="80px">
                <el-form-item label="角色名称">
                    <el-input v-model="form.roleName" :disabled="true" />
                </el-form-item>
                <el-form-item label="权限字符">
                    <el-input v-model="form.roleKey" :disabled="true" />
                </el-form-item>
                <el-form-item label="权限范围">
                    <el-select v-model="form.dataScope" @change="dataScopeSelectChange">
                        <el-option v-for="item in dataScopeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="form.dataScope === '2'" label="数据权限">
                    <el-checkbox v-model="deptExpand" @change="handleCheckedTreeExpand($event, 'dept')">展开/折叠</el-checkbox>
                    <el-checkbox v-model="deptNodeAll" @change="handleCheckedTreeNodeAll($event, 'dept')">全选/全不选</el-checkbox>
                    <el-checkbox v-model="form.deptCheckStrictly" @change="handleCheckedTreeConnect($event, 'dept')">父子联动</el-checkbox>
                    <el-tree
                    ref="deptRef"
                    class="tree-border"
                    :data="deptOptions"
                    show-checkbox
                    default-expand-all
                    node-key="id"
                    :check-strictly="!form.deptCheckStrictly"
                    empty-text="加载中，请稍候"
                    :props="{ label: 'label', children: 'children' }"
                    ></el-tree>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                <el-button type="primary" @click="submitDataScope">确 定</el-button>
                <el-button @click="cancelDataScope">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 分配用户 -->
        <el-dialog title="分配用户" :visible.sync="dialogUserVisible" width="60%" center :close-on-press-escape="false" :destroy-on-close="true" :close-on-click-modal="false">
            <AssignUser :roleId="rowRoleId" v-if="dialogUserVisible"></AssignUser>
        </el-dialog>
    </div>
</template>
<script>
import { addDateRange } from '@/utils/base';
import { Message, MessageBox} from 'element-ui'
import AssignUser from '@/components/AssignUsers/index'
export default {
    components:{
        AssignUser
    },
    data(){
        return{
            treeData: [],
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                roleName:""
            },
            multiple:false,//是否进行了多选
            dateRange:['', ''],
            dialogTitle:'',
            // 添加数据
            dialogForm: {
                roleId: 0,
                roleName: "",
                roleKey: "",
                roleSort: 0,
                dataScope: "",
                menuCheckStrictly: true,
                deptCheckStrictly: false,
                status: '0',
                remark: "",
                menuIds: [],
                deptIds: [],
                superAdmin: false
            },
            rules:{
                roleName:[{ required: true, message: '角色名称不能为空', trigger: 'blur' }]
            },
            form:{
                roleId: undefined,
                roleSort: 1,
                status: '0',
                roleName: '',
                roleKey: '',
                menuCheckStrictly: true,
                deptCheckStrictly: true,
                remark: '',
                dataScope: '1',
                menuIds: [],
                deptIds: []
            },
            dataScopeOptions:[
                { value: '1', label: '全部数据权限' },
                { value: '2', label: '自定数据权限' },
                { value: '3', label: '本部门数据权限' },
                { value: '4', label: '本部门及以下数据权限' },
                { value: '5', label: '仅本人数据权限' }
            ],
            deptExpand:true,
            deptNodeAll:false,
            deptOptions:[],
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            //角色名称
            options: [],
            dialogFormVisible:false,//是否显示添加对话框
            dialogDataVisible:false,//是否显示数据权限分配对话框
            dialogUserVisible:false,
            ids:'',
            names:'',
            rowRoleId:""
        }
    },
    mounted() {
        this.getRoleNames();
        this.getList();
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    methods: {
        // 获取角色名称下拉框
        getRoleNames(){
            this.$store.dispatch('role/optionSelect', { roleId:"" }).then((result)=>{
                if(result?.data){
                    this.options = result.data;
                }
            });
        },
        // 获取角色信息列表
        getList(){
            let params = addDateRange(this.queryParams, this.dateRange);
            this.$store.dispatch('role/getRoleList', params).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            }); 
        },
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        /** 树权限（父子联动） */
        handleCheckedTreeConnect(value, type){
        if (type == 'menu') {
            this.dialogForm.menuCheckStrictly = value;
        } else if (type == 'dept') {
            this.dialogForm.deptCheckStrictly = value;
        }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            this.dateRange = ['',''];
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                roleName:""
            };
            this.getList();
        },
        /** 查询菜单树结构 */
        async getMenuTreeselect(){
            this.$store.dispatch('role/treeselect').then((res)=>{
                this.treeData = res.data;
            });
        },
        getRightTree(roleId){
            this.$store.dispatch('role/roleMenuTreeselect', { roleId }).then((result)=>{
                if(result?.data?.menus){
                    this.treeData = result.data.menus;
                    result.data.checkedKeys.forEach((v) => {
                        this.$nextTick(() => {
                            this.$refs.tree.setChecked(v, true, false);
                        });
                    });
                }
            });
        },
        // 行修改
        handleEdit(row) {
            this.$store.dispatch('role/getRole', { roleId:row.roleId }).then((result)=>{
                if(result?.data){
                    this.dialogForm = result.data;
                    this.dialogFormVisible = true;
                    this.dialogTitle = '编辑角色信息';
                    this.getRightTree(row.roleId);
                }
            });
            
        },
        handleSelectionChange(selection){
            this.ids = selection.map((item) => item.roleId);
            this.names = selection.map((item) => item.roleName);
            this.multiple = !!selection.length;
        },
        // 行删除
        handleDelete(row){
            if(!row && !this.multiple){
                Message.warning("请先选择角色！");
                return;
            }
            let roleIds = null;
            if(row?.roleId == 0){
                roleIds = row?.roleId;
            }
            else{
                roleIds = row?.roleId || this.ids;
            }
            const roleNames = row?.roleName || this.names.join(",");
            MessageBox.confirm('是否确认删除角色名称为"' + roleNames + '"的数据项？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.$store.dispatch('role/deleteRole',{roleId:roleIds});
                this.getList();
                Message.warning('删除成功！');
            }).catch(() => { 
                
            });
        },
        /** 根据角色ID查询部门树结构 */
        async getRoleDeptTreeSelect(roleId){
            const res = await this.$store.dispatch('role/deptTreeSelect', { roleId:roleId });
            this.deptOptions = res.data.depts;
            return res.data;
        },
        // 行数据权限设置
        handleRight(row){
            this.$store.dispatch('role/getRole', { roleId:row.roleId }).then(async (response)=>{
                Object.assign(this.form, response.data);
                const res = await this.getRoleDeptTreeSelect(row.roleId);
                this.dialogDataVisible = true;
                this.$nextTick(() => {
                    this.$refs.deptRef?.setCheckedKeys(res.checkedKeys);
                });
            });
        },
        // 重置表单数据
        reset(){
            this.dialogForm = {
                roleId: 0,
                roleName: "",
                roleKey: "",
                roleSort: 0,
                dataScope: "",
                menuCheckStrictly: true,
                deptCheckStrictly: false,
                status: "0",
                remark: "",
                menuIds: [],
                deptIds: [],
                superAdmin: false
            };
        },
        // 打开修改对话框
        addClick(){
            this.reset();
            this.dialogFormVisible = true;
            this.dialogTitle = '新增角色信息';
            this.getMenuTreeselect();
        },
        // 确认修改
        handleAdd(){
            this.dialogForm.menuIds = this.getDeptAllCheckedKeys("tree");
            this.dialogForm.roleKey = 'roleKey';
            this.$refs.roleFormRef?.validate(async (valid) => {
                if (valid) {
                    if(this.dialogForm.roleId){
                        await this.updateRole(this.dialogForm);
                    }
                    else{
                        await this.addRole(this.dialogForm);
                    }
                    Message.success("操作成功");
                    this.dialogFormVisible = false;
                    await this.getList();
                }
            });
        },
        // 修改保存
        async updateRole(form){
            await this.$store.dispatch('role/editRole',form);
        },
        // 新增保存
        async addRole(form){
             await this.$store.dispatch('role/addRole',form);
        },
        getDeptAllCheckedKeys(ref){
        // 目前被选中的部门节点
            let checkedKeys = this.$refs[ref]?.getCheckedKeys();
            // 半选中的部门节点
            let halfCheckedKeys = this.$refs[ref]?.getHalfCheckedKeys();
            if (halfCheckedKeys) {
                checkedKeys?.unshift.apply(checkedKeys, halfCheckedKeys);
            }
            return checkedKeys;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        /** 选择角色权限范围触发 */
        dataScopeSelectChange(value){
            if (value !== '2') {
                this.$refs.deptRef?.setCheckedKeys([]);
            }
        },
        /** 树权限（展开/折叠）*/
        handleCheckedTreeExpand(value, type){
            if (type == 'menu') {
                let treeList = this.treeData;
                for (let i = 0; i < treeList.length; i++) {
                if (this.$refs.tree) {
                    this.$refs.tree.store.nodesMap[treeList[i].id].expanded = value;
                }
                }
            } else if (type == 'dept') {
                let treeList = this.deptOptions;
                for (let i = 0; i < treeList.length; i++) {
                if (this.$refs.deptRef) {
                    this.$refs.deptRef.store.nodesMap[treeList[i].id].expanded = value;
                }
                }
            }
        },
        /** 树权限（全选/全不选） */
        handleCheckedTreeNodeAll(value, type){
            if (type == 'menu') {
                this.$refs.tree?.setCheckedNodes(value ? (this.treeData) : []);
            } else if (type == 'dept') {
                this.$refs.deptRef?.setCheckedNodes(value ? (this.deptOptions) : []);
            }
        },
        /** 树权限（父子联动） */
        handleCheckedTreeConnect(value, type){
            if (type == 'menu') {
                this.form.menuCheckStrictly = value;
            } else if (type == 'dept') {
                this.form.deptCheckStrictly = value;
            }
        },
        /** 提交按钮（数据权限） */
        submitDataScope(){
            if (this.form.roleId) {
                this.form.deptIds = this.getDeptAllCheckedKeys("deptRef");
                this.$store.dispatch('role/dataScope', this.form).then(()=>{
                    Message.success('修改成功');
                    this.dialogDataVisible = false;
                    this.getList();
                });
            }
        },
        /** 取消按钮（数据权限）*/
        cancelDataScope(){
            this.dataScopeRef?.resetFields();
            this.form = {
                roleId: undefined,
                roleSort: 1,
                status: '0',
                roleName: '',
                roleKey: '',
                menuCheckStrictly: true,
                deptCheckStrictly: true,
                remark: '',
                dataScope: '1',
                menuIds: [],
                deptIds: []
            };
            this.dialogDataVisible = false;
        },
        // 分配用户
        handleUser(row){
            this.rowRoleId = row.roleId;
            this.dialogUserVisible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
</style>